import { render } from "./DisableOtp.vue?vue&type=template&id=53f46335&ts=true"
import script from "./DisableOtp.vue?vue&type=script&lang=ts"
export * from "./DisableOtp.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__